var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"thc-footer"}},[_vm._v("\n  © 2019 The Halfway Crooks\n")])}
var staticRenderFns = []

export { render, staticRenderFns }